import { render, staticRenderFns } from "./text-edit.vue?vue&type=template&id=72241599"
import script from "./text-edit.vue?vue&type=script&lang=js"
export * from "./text-edit.vue?vue&type=script&lang=js"
import style0 from "./text-edit.vue?vue&type=style&index=0&id=72241599&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports